export default __webpack_public_path__ + "static/media/kiricocho-logo.7ef33cbc.svg";